import { Flex, Modal, ModalBody, ModalContent, ModalOverlay, Text, Button } from '@chakra-ui/react';
import { FC } from 'react';
import { ShouldDisplayData } from '../../../api/deadbeat';
import { Divider } from '../../../lib/components/Divider';
import { PrimaryButton } from '../../../lib/components/PrimaryButton';

type DeadbeatModalProps = {
  onClose: () => void;
  isOpen: boolean;
  data: ShouldDisplayData;
}

const DeadbeatModal: FC<DeadbeatModalProps> = ({
  isOpen, onClose, data,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="428px" borderRadius="8px" p="0px">
        <ModalBody p="0px">
          <Flex flexDir="column" p="16px" justifyContent="flex-start">
            <Text
              mb="20px"
              fontSize="22px"
            >
              {data.title}
            </Text>
            {
              data.text?.map(t => (<Text fontSize="14px">{t.length === 0 ? '\u00A0' : t}</Text>))
            }
          </Flex>
          <Divider />
          <Flex p="16px" justifyContent="flex-end">
            <Button onClick={onClose} mr="16px" variant="link" sx={{ px: '8px' }} paddingInline="8px">
              Fechar
            </Button>
            <PrimaryButton
              onClick={onClose}
            >
              Fale conosco
            </PrimaryButton>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DeadbeatModal;
